export default "__VITE_PUBLIC_ASSET__d657c64e__"